import { defineStore } from "pinia";
import { isObject } from "lodash";
import { useUser } from "./user";
import { SessionStorage } from "@/storage";
import { applicationType, initType } from "@/types/application";
import { init } from "@/api/apiclient/user";
import { useFavicon } from "@vueuse/core";

export const useSettings = defineStore("settings", {
  state: () => {
    return {
      platformId: "HAWAY",
      platformIdHeader: import.meta.env.VITE_PLATFORM_HEADER,
      platformFrontendId: import.meta.env.VITE_CLIENT_ID,
      authInitialized: false,
      mode: import.meta.env.MODE,
      sidebaSize: SessionStorage.getOr("HDHappywaySidebarSize", "open"),
      applicationInfo: null as null | Partial<applicationType>
    };
  },
  actions: {
    async init(): Promise<initType | null>{
      try {
        const res = await init();
        useSettings().setApplicationInfo(res.context);
        const icon = useFavicon();
        icon.value = res.context?.favicon;

        return res;
      } catch (error) {
        console.error(error);
      }
      return null;
    },
    setSidebarSize(str: string): void{
      this.sidebaSize = str;
    },
    setApplicationInfo(obj:Partial<applicationType>): void {
      this.applicationInfo = {...obj};
    }
  },
  getters: {
    cleanObj() {
      return (obj: any) => {
        return cleanObj(obj);
      };
    },
    getSidebarSize(): string {
      return this.sidebaSize;
    },
    getUserRoleId() {
      return (): number | null => {
        return useUser().savedRole?.id ?? null;
      };
    },
    getPrefixesList () {
      return [
        { n: "Italy", c: "+39", iso: "it" },
        { n: "Albania", c: "+355", iso: "al" },
        { n: "Andorra", c: "+376", iso: "ad" },
        { n: "Armenia", c: "+374", iso: "am" },
        { n: "Austria", c: "+43", iso: "at" },
        { n: "Azerbaijan", c: "+994", iso: "az" },
        { n: "Belarus", c: "+375", iso: "by" },
        { n: "Belgium", c: "+32", iso: "be" },
        { n: "Bosnia and Herzegovina", c: "+387", iso: "ba" },
        { n: "Brazil", c: "+55", iso: "br" },
        { n: "Bulgaria", c: "+359", iso: "bg" },
        { n: "China", c: "+86", iso: "cn" },
        { n: "Croatia", c: "+385", iso: "hr" },
        { n: "Cyprus", c: "+357", iso: "cy" },
        { n: "Czech Republic", c: "+420", iso: "cz" },
        { n: "Denmark", c: "+45", iso: "dk" },
        { n: "Estonia", c: "+372", iso: "ee" },
        { n: "Finland", c: "+358", iso: "fi" },
        { n: "France", c: "+33", iso: "fr" },
        { n: "Georgia", c: "+995", iso: "ge" },
        { n: "Germany", c: "+49", iso: "de" },
        { n: "Greece", c: "+30", iso: "gr" },
        { n: "Holy See (Vatican City)", c: "+379", iso: "va" },
        { n: "Hungary", c: "+36", iso: "hu" },
        { n: "Iceland", c: "+354", iso: "is" },
        { n: "India", c: "+91", iso: "in" },
        { n: "Ireland", c: "+353", iso: "ie" },
        { n: "Latvia", c: "+371", iso: "lv" },
        { n: "Liechtenstein", c: "+423", iso: "li" },
        { n: "Lithuania", c: "+370", iso: "lt" },
        { n: "Luxembourg", c: "+352", iso: "lu" },
        { n: "Malta", c: "+356", iso: "mt" },
        { n: "Moldova", c: "+373", iso: "md" },
        { n: "Monaco", c: "+377", iso: "mc" },
        { n: "Montenegro", c: "+382", iso: "me" },
        { n: "Netherlands", c: "+31", iso: "nl" },
        { n: "North Macedonia", c: "+389", iso: "mk" },
        { n: "Norway", c: "+47", iso: "no" },
        { n: "Poland", c: "+48", iso: "pl" },
        { n: "Portugal", c: "+351", iso: "pt" },
        { n: "Romania", c: "+40", iso: "ro" },
        { n: "Russia", c: "+7", iso: "ru" },
        { n: "San Marino", c: "+378", iso: "sm" },
        { n: "Serbia", c: "+381", iso: "rs" },
        { n: "Slovakia", c: "+421", iso: "sk" },
        { n: "Slovenia", c: "+386", iso: "si" },
        { n: "Spain", c: "+34", iso: "es" },
        { n: "Sweden", c: "+46", iso: "se" },
        { n: "Switzerland", c: "+41", iso: "ch" },
        { n: "Turkey", c: "+90", iso: "tr" },
        { n: "Ukraine", c: "+380", iso: "ua" },
        { n: "United Kingdom", c: "+44", iso: "gb" },
        { n: "United States", c: "+1", iso: "us" },
      ];
    },
    getLogo(): string {
      if( this.applicationInfo?.logo  !== null ){
        return this.applicationInfo?.logo ?? '';
      }
      return '';
    }
  },
});

const cleanObj = (obj: any) => {
  Object.keys(obj).map((k) => {
    if (isObject(obj[k])) {
      cleanObj(obj[k]);
      if (Object.keys(obj[k]).length === 0) delete obj[k];
    } else {
      Object.keys(obj).map((k) => (obj[k] == null ? delete obj[k] : obj[k]));
    }
  });
  return obj;
};
